import { TICKER_SYMBOLS } from "../lib/constants";

// Inverted strip: black ground, lime symbols, hard vertical dividers. No edge
// fades — the marquee clips against the black edge and that is the point.
function TickerRow() {
    return (
        <>
            {TICKER_SYMBOLS.map((t, i) => (
                <span
                    key={i}
                    data-testid={`ticker-item-${t.symbol.replace(/[^a-zA-Z0-9]/g, "")}`}
                    className="inline-flex items-baseline gap-2.5 px-5 border-r-2 border-canvas/25 font-mono text-[11px] font-bold uppercase tracking-wider"
                >
                    <span className="text-accent">{t.symbol}</span>
                    <span className="text-canvas tabular-nums">{t.value}</span>
                    <span className={t.up ? "text-pos tabular-nums" : "text-neg tabular-nums"}>
                        {t.change}
                    </span>
                </span>
            ))}
        </>
    );
}

export function StockTicker() {
    return (
        <div
            className="relative h-9 flex items-center overflow-hidden border-b-[3px] border-foreground bg-foreground"
            data-testid="stock-ticker"
        >
            <span className="hidden sm:inline-flex items-center gap-2 h-full px-4 shrink-0 border-r-[3px] border-foreground bg-accent">
                <span className="w-2 h-2 bg-accent-foreground animate-pulse-dot" />
                <span className="eyebrow text-accent-foreground">Markets</span>
            </span>
            <div className="relative flex-1 overflow-hidden">
                <div className="ticker-track">
                    <TickerRow />
                    <TickerRow />
                </div>
            </div>
        </div>
    );
}
